import styled from 'styled-components';
export var Footer = styled.div.withConfig({
  displayName: "Footer",
  componentId: "sc-5figi3-0"
})(["display:block;padding:0 22px 8px;margin-top:auto;"]);